<div
  [ngClass]="{
    'accordion-panel--expanded': expandedState(),
    'accordion-panel--bordered': hasBorder(),
  }"
  class="accordion-panel"
>
  <button
    (click)="toggleExpanded()"
    [attr.aria-controls]="`accordion-panel__body-${id}`"
    [attr.aria-expanded]="expandedState()"
    class="accordion-panel__header"
    id="{{ `accordion-panel__header-${id}` }}"
    type="button"
  >
    <ng-container
      [ngTemplateOutlet]="
        accordionPanelHeaderTemplate() || defaultAccordionPanelHeaderTemplate
      "
      [ngTemplateOutletContext]="{
        $implicit: panel(),
        panel: panel(),
        title: title(),
        expanded: expandedState(),
      }"
    />
  </button>

  @if (expandedState()) {
    <div
      [animate.enter]="'accordion-panel__body--open'"
      [animate.leave]="'accordion-panel__body--closed'"
      [attr.aria-labelledby]="`accordion-panel__header-${id}`"
      class="accordion-panel__body"
      id="{{ `accordion-panel__body-${id}` }}"
      role="region"
    >
      <div class="accordion-panel__body-inner">
        <ng-container
          [ngTemplateOutlet]="
            accordionPanelContentTemplate() ||
            defaultAccordionPanelContentTemplate
          "
          [ngTemplateOutletContext]="{
            $implicit: panel(),
            panel: panel(),
            body: body(),
            expanded: expandedState(),
          }"
        />
      </div>
    </div>
  }
</div>

<ng-template
  #defaultAccordionPanelHeaderTemplate
  let-panel="panel"
  let-title="title"
>
  <span class="accordion-panel__header--default">
    <span class="accordion-panel__header-title">
      {{ title ?? panel?.title }}
    </span>

    <i class="accordion-panel__header-icon fa-solid fa-chevron-down"></i>
  </span>
</ng-template>

<ng-template
  #defaultAccordionPanelContentTemplate
  let-body="body"
  let-panel="panel"
>
  <p>
    {{ body ?? panel?.body }}
  </p>
  <ng-content />
</ng-template>
